module.exports = __webpack_public_path__ + "static/media/whiteclock.750bd25e.svg";